export default __webpack_public_path__ + "static/Fig 8 - Construction Compound Detail-0881d1d3e7069496290af2519827af5d.pdf";